<template>
  <div id="app" :class="{ '': !isDarkMode, 'bg-dark dark-mode': isDarkMode }">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  metaInfo: {
    title: 'App',
    titleTemplate: '%s | Spencer',
    meta: []
    
  },
  computed: {
     ...mapState('darkMode', ['isDarkMode']),
    layout() {
      return this.$route.meta.layout || 'simple-layout';
    }
  },
  mounted() {
  if (this.isDarkMode) {
    document.body.classList.add('dark-mode');
  }
}
};
</script>

<style lang="scss">
#app {
  // prettier-ignore
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top: 4.5rem;
}

:root {
  --primary-color:#29374513;
}


.swal-dark-mode {
  background: #1e1e1e !important;
  color: #edebeb !important;
}

.swal-dark-mode a {
  color: #4da3ff !important;
}


.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #333;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.dark-mode .spinner,
.dark-mode .spinner-black {
  border-color: rgba(255, 255, 255, 0.2) !important;
  border-top-color: #ffffff !important;
}
@import '../src/assets/css/custom.css';
</style>
